export const GET_USER_GROUP = 'GET_USER_GROUP';
export const UPDATE_SELECTED_DEALER = 'UPDATE_SELECTED_DEALER';
export const GET_USER = 'GET_USER';
export const API_ERROR = 'API_ERROR';
export const CLEAR_API_ERROR = 'CLEAR_API_ERROR';